import { AsyncDuckDB } from '@duckdb/duckdb-wasm';
import * as shell from '@duckdb/duckdb-wasm-shell';
import shell_wasm from '@duckdb/duckdb-wasm-shell/dist/shell_bg.wasm?url';
import { Box, useTheme } from '@mui/material';
import React, { useCallback } from 'react';
import 'xterm/css/xterm.css';
import { useDuckDb } from './third-party-kit/hooks/useDuckDb';

export const Shell: React.FC = () => {
  const theme = useTheme();
  const termContainer = React.useRef<HTMLDivElement | null>(null);
  const { db, error } = useDuckDb();
  // const shellStatusUpdater = React.useRef<duckdb.InstantiationProgressHandler | null>(null);
  // Embed the shell into the term container
  const embedShell = useCallback(
    async (db: AsyncDuckDB, container: HTMLDivElement) => {
      await shell.embed({
        shellModule: shell_wasm,
        container: container,
        resolveDatabase: async () => db,
        /**
         * This is an edge case where I couldn't use the
         * CSS Variable version (theme.vars.palette), because
         * this shell gets embedded into the app via some iframes,
         * which isolates it from the theme.
         */
        backgroundColor: theme.palette.background.paper,
      });
    },
    []
  );

  React.useEffect(() => {
    if (termContainer.current != null && !!db) {
      embedShell(db, termContainer.current);
    }
  }, [db, error]);

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        overflow: 'auto',
        padding: '16px 0 0 20px',
        backgroundColor: theme.vars.palette.background.paper,
      }}
    >
      <div ref={termContainer} />
    </Box>
  );
};
